module.exports = __webpack_public_path__ + "static/media/byjus.270bfda9.png";